import { Box, Flex, Heading, useMediaQuery } from '@chakra-ui/react';
import useTranslation from 'next-translate/useTranslation';
import { BlogPostsMainData } from '@/Types/types';
import Post from './Post';

interface Props {
  data: BlogPostsMainData[];
}

export default function YouMayAlsoLikeContainer({ data }: Props) {
  const [isMobileScreen] = useMediaQuery('(max-width: 984px)');

  const { t } = useTranslation('common');

  return (
    <Box
      as="section"
      width="90%"
      maxW="1216px"
      m="0 auto"
      bgColor="gray.50"
      paddingBottom={{ base: '60px', lg: '80px' }}
      paddingTop={{ base: '0px', lg: '0px' }}
      mt="160px"
    >
      <Heading as="h2" width="90%" textAlign="left" m="0 auto 32px 0">
        {t('article.youMayAlsoLike.title')}
      </Heading>

      {data && !isMobileScreen && data.length >= 2 ? (
        <Flex gap="32px" direction={{ base: 'column', md: 'row' }}>
          <Flex direction="column" gap="32px" maxW="794px" minW="380px" flexGrow="2">
            {data.slice(0, 2).map((item: BlogPostsMainData, index: number) => (
              <Post key={index} post={item} hasImage hasCategory isHorizontal hasParagraph />
            ))}
          </Flex>

          <Post post={data[2]} hasImage hasCategory hasParagraph />
        </Flex>
      ) : (
        <Flex gap="32px" direction="column">
          {data.map((item: BlogPostsMainData, index: number) => (
            <Post key={index} post={item} hasImage hasCategory isHorizontal hasParagraph />
          ))}
        </Flex>
      )}
    </Box>
  );
}
